export default __webpack_public_path__ + "static/media/326-2.c9f56dc7.jpg";